const formFieldsHardware = [
  {
    key: 'name',
    label: 'Hardware',
    type: 'text',
    isRequired: true,
  },
  {
    key: 'countNeeded',
    label: 'Count Needed',
    type: 'number',
  },
  {
    key: 'leadTime',
    label: 'Lead Time',
    type: 'time',
    decoratorWord: 'months',
  },
  {
    key: 'costPerUnit',
    label: 'Cost Per Unit',
    type: 'money',
  },
  { type: 'autocomplete' },
];

export { formFieldsHardware };
